import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'typed-redux-saga';
import thunk from 'redux-thunk';
import appMessagesSaga from './appMessages/sagas';
import topicsSaga from './topics/sagas';
import { authReducer } from './auth/reducers';
import { appMessagesReducer } from './appMessages/reducers';
import {
  antonymsReducer, createAntonymReducer, createSynonymReducer, synonymsReducer, topicsReducer, topicSyncStateReducer,
} from './topics/reducers';

const rootReducer = combineReducers({
  auth: authReducer,
  appMessages: appMessagesReducer,
  topicState: topicsReducer,
  synonyms: synonymsReducer,
  antonyms: antonymsReducer,
  topicSyncState: topicSyncStateReducer,
  synonymCreateState: createSynonymReducer,
  antonymCreateState: createAntonymReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

// export default function configureStore() {
const configureStore = () => {
  const composeEnhancers = composeWithDevTools({});
  // create the redux-saga middleware
  const sagaMiddleware = createSagaMiddleware();

  // We'll create our store with the combined reducers/sagas, and the initial Redux state that
  // we'll be passing from our entry point.
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware, thunk)),
  );

  sagaMiddleware.run(rootSaga);
  return store;
};

export const store = configureStore();

export function* rootSaga() {
  yield all([fork(topicsSaga), fork(appMessagesSaga)]);
}

type RootState = ReturnType<typeof rootReducer>;
export type { RootState as default };
